<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jcmj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Extrusion Mould</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p style="text-align:left;text-indent:9.0pt;background:#F9F9F9;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;">PVC</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#4B4B4B;">plastic steel doors and windows, guardrail mould.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;"></span>
      </p>
      <p style="text-align:left;text-indent:9.0pt;background:#F9F9F9;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;">PVC</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#4B4B4B;">co-extrusion die，multicolor co-extrusion，multi-layer co-extrusion，foaming co-extrusion mould</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;"></span>
      </p>
      <p style="text-align:left;text-indent:9.0pt;background:#F9F9F9;" align="left">
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;">PVC</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#4B4B4B;">trunking, wire tube, communication tube, multi-cavity tube, foaming tube, plate and strip mould</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#4B4B4B;"></span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jcmj: require("../../../assets/img/common/jcmj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/jcmj.vue